import React, { lazy, Suspense, useState, useEffect } from "react";
import { getLBUIdentifier } from "../../../../utils/common-utils";

interface CreateAccountProps {
  onClick: () => void;
  t: (key: string) => string;
}

export const DynamicCreateAccountButton: React.FC<CreateAccountProps> = (props) => {
  const [Component, setComponent] = useState<React.LazyExoticComponent<any> | null>(null);

  useEffect(() => {
    const lbu = getLBUIdentifier();
    // Dynamically import the component
    const loadComponent = async () => {
      try {
        const path = lbu === "coe" ? "./create-account-button" : `./${lbu}/create-account-button`;
        const module = await import(path);
        setComponent(() => React.lazy(() => Promise.resolve({ default: module.default })));
      } catch (error) {
        console.log(`Failed to load component for LBU: ${lbu}, falling back to default.`, error);
        const defaultModule = await import("./create-account-button");
        setComponent(() => React.lazy(() => Promise.resolve({ default: defaultModule.default })));
      }
    };

    loadComponent();
  }, []);

  if (!Component) {
    return null;
  }

  return (
    <Suspense>
      <Component {...props} />
    </Suspense>
  );
};
